const WSPRule = () => {
    return <hr className="h-px my-2 bg-[#AEB2B5] border-0"/>
};

export default WSPRule;
